// Configuration
//import AuthConfig from "./../configuration/auth.json";

console.log(`Http requests to: ${process.env.REACT_APP_SERVER_PROTOCOL}://${process.env.REACT_APP_SERVER_DOMAIN}:${process.env.REACT_APP_SERVER_PORT}${process.env.REACT_APP_SERVER_POSTFIX}`);
console.log(`Websockets to: ${process.env.REACT_APP_WEBSOCKET_PROTOCOL}://${process.env.REACT_APP_WEBSOCKET_DOMAIN}:${process.env.REACT_APP_WEBSOCKET_PORT}${process.env.REACT_APP_WEBSOCKET_POSTFIX}`);

// Main route to server
const getHostURL = function() {
  return `${process.env.REACT_APP_SERVER_PROTOCOL}://${process.env.REACT_APP_SERVER_DOMAIN}:${process.env.REACT_APP_SERVER_PORT}${process.env.REACT_APP_SERVER_POSTFIX}`;
};

const getUserURL = function (){
  return getHostURL() + "/user";
};

const getLotteryURL = function (){
  return getHostURL() + "/lottery";
};

const getAuthURL = function (){
  return getHostURL() + "/auth";
};

// Requires user logged in and signed cookie token included.

const getAuthVerifyURL = function (){
  return getAuthURL() + "/verify";
};

const getAuthUserURL = function (){
  return getAuthURL() + "/user";
};

const getAuthLotteryURL = function (){
  return getAuthURL() + "/lottery";
};

const getAuthWalletURL = function (){
  return getAuthURL() + "/wallet";
};

// Websocket
const getWebsocketURL = function (){
  return `${process.env.REACT_APP_WEBSOCKET_PROTOCOL}://${process.env.REACT_APP_WEBSOCKET_DOMAIN}:${process.env.REACT_APP_WEBSOCKET_PORT}${process.env.REACT_APP_WEBSOCKET_POSTFIX}`;
};

export {
  getHostURL,
  getUserURL,
  getLotteryURL,
  getAuthURL,
  getAuthVerifyURL,
  getAuthUserURL,
  getAuthLotteryURL,
  getAuthWalletURL,
  getWebsocketURL,
}
